import { buildBoothDeck } from '../_booth-base/booth-base';
import { LONDON_CONFIG } from './config';

export default buildBoothDeck(LONDON_CONFIG);
